import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Vercel Remote Cache가 이제 무료입니다",
  "description": "Vercel에 연결된 저장소를 위한 무료 원격 캐싱",
  "date": "2024/12/20",
  "tag": "web development",
  "ogImage": "/images/blog/free-vercel-remote-cache/x-card.png"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo의 가장 중요한 기능 중 하나는 원격 캐싱입니다. 이는 개발자와 CI가 동일한 작업을 두 번 수행하지 않도록 보장하는 분산 캐싱 레이어입니다."
  }, {
    "heading": "",
    "content": "오늘부터 Vercel Remote Cache는 Vercel에 연결된 모든 Turborepo에 대해 무료로 제공되는 설정 불필요 옵션이 되었으며, 커뮤니티에서 만든 오픈소스 원격 캐시와 함께 개발 속도를 높이는 무료 옵션으로 제공됩니다."
  }, {
    "heading": "vercel에서",
    "content": "Vercel에서 turbo를 사용하는 명령은 자동으로 Vercel Remote Cache를 사용하도록 구성됩니다. 빌드는 설정 없이도 원격 캐싱의 이점을 누릴 수 있습니다."
  }, {
    "heading": "다른-지속적-통합-제공업체에서",
    "content": "TURBO_TOKEN 및 TURBO_TEAM 환경 변수를 생성하여 각각의 값으로 Vercel Remote Cache에 인증합니다. 다음에 연결하는 방법을 알아보려면 CI 제공업체 문서를 참조하십시오:"
  }, {
    "heading": "다른-지속적-통합-제공업체에서",
    "content": "GitHub Actions"
  }, {
    "heading": "다른-지속적-통합-제공업체에서",
    "content": "GitLab CI"
  }, {
    "heading": "다른-지속적-통합-제공업체에서",
    "content": "CircleCI"
  }, {
    "heading": "다른-지속적-통합-제공업체에서",
    "content": "GitLab CI"
  }, {
    "heading": "다른-지속적-통합-제공업체에서",
    "content": "Travis CI"
  }, {
    "heading": "다른-지속적-통합-제공업체에서",
    "content": "기타 CI 제공업체"
  }, {
    "heading": "로컬-머신에서",
    "content": "로컬에서 시작하려면 다음을 실행하십시오:"
  }, {
    "heading": "추가-정보",
    "content": "자세한 내용은 Vercel의 변경 로그 공지 또는 Vercel Remote Cache 문서를 참조하십시오."
  }],
  "headings": [{
    "id": "저장소를-vercel-remote-cache에-연결하기",
    "content": "저장소를 Vercel Remote Cache에 연결하기"
  }, {
    "id": "vercel에서",
    "content": "Vercel에서"
  }, {
    "id": "다른-지속적-통합-제공업체에서",
    "content": "다른 지속적 통합 제공업체에서"
  }, {
    "id": "로컬-머신에서",
    "content": "로컬 머신에서"
  }, {
    "id": "추가-정보",
    "content": "추가 정보"
  }]
};
export const toc = [{
  depth: 2,
  url: "#저장소를-vercel-remote-cache에-연결하기",
  title: _jsx(_Fragment, {
    children: "저장소를 Vercel Remote Cache에 연결하기"
  })
}, {
  depth: 3,
  url: "#vercel에서",
  title: _jsx(_Fragment, {
    children: "Vercel에서"
  })
}, {
  depth: 3,
  url: "#다른-지속적-통합-제공업체에서",
  title: _jsx(_Fragment, {
    children: "다른 지속적 통합 제공업체에서"
  })
}, {
  depth: 3,
  url: "#로컬-머신에서",
  title: _jsx(_Fragment, {
    children: "로컬 머신에서"
  })
}, {
  depth: 2,
  url: "#추가-정보",
  title: _jsx(_Fragment, {
    children: "추가 정보"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Vercel Remote Cache가 이제 무료입니다"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo의 가장 중요한 기능 중 하나는 ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching",
        children: "원격 캐싱"
      }), "입니다. 이는 개발자와 CI가 동일한 작업을 두 번 수행하지 않도록 보장하는 분산 캐싱 레이어입니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["오늘부터 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache"
      }), "는 Vercel에 연결된 모든 Turborepo에 대해 무료로 제공되는 설정 불필요 옵션이 되었으며, ", _jsx(_components.a, {
        href: "/docs/core-concepts/remote-caching#community-implementations",
        children: "커뮤니티에서 만든 오픈소스 원격 캐시"
      }), "와 함께 개발 속도를 높이는 무료 옵션으로 제공됩니다."]
    }), "\n", _jsx(_components.h2, {
      id: "저장소를-vercel-remote-cache에-연결하기",
      children: "저장소를 Vercel Remote Cache에 연결하기"
    }), "\n", _jsx(_components.h3, {
      id: "vercel에서",
      children: "Vercel에서"
    }), "\n", _jsxs(_components.p, {
      children: ["Vercel에서 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 사용하는 명령은 자동으로 Vercel Remote Cache를 사용하도록 구성됩니다. 빌드는 설정 없이도 원격 캐싱의 이점을 누릴 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "다른-지속적-통합-제공업체에서",
      children: "다른 지속적 통합 제공업체에서"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "TURBO_TOKEN"
      }), " 및 ", _jsx(_components.code, {
        children: "TURBO_TEAM"
      }), " 환경 변수를 생성하여 각각의 값으로 Vercel Remote Cache에 인증합니다. 다음에 연결하는 방법을 알아보려면 ", _jsx(_components.a, {
        href: "/docs/guides/ci-vendors",
        children: "CI 제공업체 문서"
      }), "를 참조하십시오:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/github-actions",
          children: "GitHub Actions"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/gitlab-ci",
          children: "GitLab CI"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/circleci",
          children: "CircleCI"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/gitlab-ci",
          children: "GitLab CI"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors/travis-ci",
          children: "Travis CI"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/guides/ci-vendors#general-setup",
          children: "기타 CI 제공업체"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "로컬-머신에서",
      children: "로컬 머신에서"
    }), "\n", _jsx(_components.p, {
      children: "로컬에서 시작하려면 다음을 실행하십시오:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "npx"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "추가-정보",
      children: "추가 정보"
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "https://vercel.com/changelog/free-vercel-remote-cache",
        children: "Vercel의 변경 로그 공지"
      }), " 또는 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache 문서"
      }), "를 참조하십시오."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
